import { CloudDrizzle, CloudFog, CloudLightning, CloudRain, CloudSnow, Cloudy, Sun, SunDim } from "lucide-react";

// Open-Meteo weather codes -> icon + translation key
export const conditionOf = (code, isDay = true) => {
  if (code === 0) return { icon: isDay ? Sun : SunDim, key: "clear" };
  if (code <= 2) return { icon: SunDim, key: "partly" };
  if (code === 3) return { icon: Cloudy, key: "cloudy" };
  if (code <= 48) return { icon: CloudFog, key: "fog" };
  if (code <= 57) return { icon: CloudDrizzle, key: "drizzle" };
  if (code <= 67) return { icon: CloudRain, key: "rain" };
  if (code <= 77) return { icon: CloudSnow, key: "snow" };
  if (code <= 82) return { icon: CloudRain, key: "showers" };
  if (code <= 86) return { icon: CloudSnow, key: "snow" };
  return { icon: CloudLightning, key: "storm" };
};

export const humidityLevel = (v) => (v >= 70 ? "high" : v >= 35 ? "comfy" : "dry");
export const uvLevel = (v) => (v >= 8 ? "extreme" : v >= 6 ? "high" : v >= 3 ? "moderate" : "low");
export const windLevel = (v) => (v >= 40 ? "strong" : v >= 20 ? "fresh" : "calm");
